import { Component, OnInit, Renderer2, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit, OnDestroy {
  // supportQuestions = [];
  // accordionIndex = 0;

  public s = this.renderer2.createElement('script');

  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private _document) {}

  ngOnInit() {
    this.s.type = 'text/javascript';
    this.s.src = 'https://desk.zoho.com/portal/api/web/inapp/77883000016034013?orgId=46799948';
    this.s.text = ``;

    this.renderer2.appendChild(this._document.body, this.s);

    // this.setSupportQuestions();
  }

  // setSupportQuestions() {
  //  this.supportQuestions = [
  //    {
  //      title: 'How do I contact Barbour Logic support?',
  //      content: `To help us help you, please:
  //                <ul class="accordionList">
  //                    <li class="accordionList">take screenshots;</li>
  //                    <li class="accordionList">explain what you clicked; and</li>
  //                    <li class="accordionList">send this to us at support@barbourlogic.co.uk</li>
  //                </ul>
  //                We'll get back to you promptly.`
  //    },
  //    {
  //      title: 'How do I create a new user?',
  //      content: `If Response Master <span class="bold">isn't</span> interfaced with your notice-processing system:
  //                <ol class="accordionList">
  //                    <li class="accordionList">Click <span class="primary">admin</span> then <span class="primary">view users</span>.</li>
  //                    <li class="accordionList">Click <span class="primary">user id</span> to order the list by user id.</li>
  //                    <li class="accordionList">Make a note of the highest id number.</li>
  //                    <li class="accordionList">Click <span class="primary">add user</span>.</li>
  //                    <li class="accordionList">Enter the details.<br><span class="bold">Note</span>: for <span class="primary">user id</span>, enter a number that's one greater than the number you noted in step 3. Eg if you noted 28, enter 29.</li>
  //                    <li class="accordionList">Click <span class="primary">create</span>.</li>
  //                </ol>
  //                If Response Master <span class="bold">is</span> interfaced with your notice-processing system:
  //                <ol class="accordionList">
  //                    <li class="accordionList">Click <span class="primary">admin</span> then <span class="primary">add user</span>.</li>
  //                    <li class="accordionList">Enter the details.<br><span class="bold">Note</span>: the <span class="primary">user id</span> <span class="bold">must</span> be identical to the user's id in your notice-processing system.</li>
  //                    <li class="accordionList">Click <span class="primary">create</span>.</li>
  //                </ol>`
  //    },
  //    {
  //      title: "How do I edit a user's details ?",
  //      content: `<ol class="accordionList">
  //                    <li class="accordionList">Click <span class="primary">admin</span> then <span class="primary">view users</span>.</li>
  //                    <li class="accordionList">Click on the relevant user's name.</li>
  //                    <li class="accordionList">Edit their details then click <span class="primary">save</span>.</li>
  //                </ol>`
  //    },
  //    {
  //      title: 'How do I reset a password?',
  //      content: `<ol class="accordionList">
  //                    <li class="accordionList">Click <span class="primary">admin</span> then <span class="primary">view users</span>.</li>
  //                    <li class="accordionList">Click on the relevant user's name.</li>
  //                    <li class="accordionList">Enter and confirm the password then click <span class="primary">save</span>.</li>
  //                </ol>`
  //    },
  //    {
  //      title: "How do I access admin or reports - they're greyed out?",
  //      content: `Your supervisor or someone with admin access needs to do this:
  //                <ol class="accordionList">
  //                    <li class="accordionList">Click <span class="primary">admin</span> then <span class="primary">view users</span>.</li>
  //                    <li class="accordionList">Click on the relevant user's name.</li>
  //                    <li class="accordionList">Set <span class="primary">admin access</span> / <span class="primary">reports access</span> to <span class="primary">yes</span>. Then click <span class="primary">save</span>.</li>
  //                    <li class="accordionList">If the button(s) are still greyed out, please ask your IT colleagues to clear your internet cache.</li>
  //                </ol>`
  //    },
  //    {
  //      title: "Error message: 'Could not get bean for...' What should I do?",
  //      content: `Example: Could not get bean for external user id 235<br>
  //                Sproc:S_FindResponseMasterUserByExternalUserID<br><br>
  //                Please send us the following information:
  //                <ol class="accordionList">
  //                    <li class="accordionList">The full error message.</li>
  //                    <li class="accordionList">Did a <span class="bold">new</span> user get the error message?</li>
  //                    <li class="accordionList">Click <span class="primary">admin</span> and take a screenshot of the users.</li>
  //                    <li class="accordionList">Click on the name of:
  //                        <ul class="accordionListSub">
  //                            <li class="accordionList">the user who got the error message and take a screenshot of their details;</li>
  //                            <li class="accordionList">a user who didn't get the error message and take a screenshot of their details.</li>
  //                        </ul>
  //                    </li>
  //                </ol>`
  //    },
  //    {
  //      title: "Error message: 'DB command failure'. What should I do?",
  //      content: `Example: error DBR6001: DB command failure, could be a read or write error.<br>
  //                Sproc Name: S_FindActiveAlerts Parameters: AnsiString @pcnNumber PL21133469 Input AnsiString @Reasons [ 1 = 0 ] Input AnsiString @Documents [ 1 = 0 ] Input AnsiString @Policies [ 1 = 0 ] Input Possible sql: S_FindActiveAlerts 'AA21133469', '[ 1 = 0 ]', '[ 1 = 0 ]', '[ 1 = 0 ]'<br><br>
  //                Please send us the following information:
  //                <ol class="accordionList">
  //                    <li class="accordionList">The full error message.</li>
  //                    <li class="accordionList">Has this happened on one case or several? If several, please provide some PCN numbers.</li>
  //                    <li class="accordionList">Exactly what is your notice-processing system showing in its 'location' field, eg <i>Cranley Road</i>, for these cases?</li>
  //                </ol>`
  //    },
  //  ];
  // }

  ngOnDestroy() {
    this.renderer2.removeChild(this._document.body, this.s);
    this._document.getElementById('zohohc-asap-web-helper-main').remove();
  }
}
